import "core-js/modules/es6.function.name";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "sys-menu-box"
  }, [_c('Menu', {
    ref: "menu",
    attrs: {
      "theme": "light",
      "width": "auto",
      "active-name": _vm.activeName,
      "open-names": _vm.openNames
    }
  }, _vm._l(_vm.menuList, function (item) {
    return _c('SysMenuItem', {
      key: item.name,
      attrs: {
        "item": item
      }
    });
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };